import './style.scss';
import template from './hemCalculator.html';
import HemCalculatorCtrl from './hemCalculatorCtrl';

export default {
  template,
  controller: HemCalculatorCtrl,
  controllerAs: 'vm',
};
